export default "__VITE_ASSET__BOhjDd05__"